<template>
    <div>
        <p v-if="titulo" class="is-flex is-justify-content-center mt-3">
            <span id="timeline-header" class="has-text-weight-bold px-4 py-2">
                {{ titulo }}
            </span>
        </p>

        <div id="timeline-container" class="mb-5">
            <div
                v-for="(dado, index) in dados"
                :key="dado.nome"
                class="is-flex is-justify-content-center"
                :class="{ 'pt-6': index != 0 || titulo }"
            >
                <div class="is-flex-grow-3 is-flex-basis-0 has-text-right my-auto">
                    {{ dado.leftText }}
                </div>
                <div class="my-auto mx-3 is-z-index-1">
                    <span class="icon" :title="dado.icon.title">
                        <i v-if="dado.icon" class="mdi is-size-3" :class="dado.icon.name" :style="dado.icon.style"></i>
                        <i v-else class="mdi mdi-moon-full is-size-3 icon-default-color"></i>
                    </span>
                </div>
                <div class="is-flex-grow-3 is-flex-basis-0 my-auto">
                    {{ dado.rightText }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SimpleTimeline",
    props: {
        titulo: {
            type: String,
            default: ''
        },
        dados: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
    #timeline-header {
        background-color: var(--primaryColor, #A82339);
        color: white;
        border-radius: 1rem;
    }

    #timeline-container {
        position: relative;
        width: 100%;
    }

    #timeline-container::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 1px;
        background-color: hsl(0deg, 0%, 86%);
    }

    .is-flex-basis-0 {
        flex-basis: 0px;
    }

    .is-z-index-1 {
        z-index: 1;
    }

    .icon-default-color {
        color: #d9d9d9
    }

    .icon {
        background-color: white;
        border-radius: 20px;
    }
</style>